import BaseService from './baseService'
import { Timezone } from '@/types/timezone'

class TimezoneService extends BaseService {
  getTimezones = async () => {
    const response: { data: Timezone[] } =
      await this.apiClient.get('/timezones')
    return response.data as Timezone[]
  }

  getTimeZoneById = async (timeZoneId: number) => {
    const response: { data: Timezone } = await this.apiClient.get(
      `/timezones/${timeZoneId}`
    )
    return response.data
  }
}

export default TimezoneService
